import { ButtonProps } from "primereact/button";
import React from "react";

import {
  StyledBtn,
  StyledMessageButtons,
} from "../MessageContent/MessageButtons";

const NewMessageButtons: React.FC<ButtonProps> = ({}) => {
  return (
    <StyledMessageButtons className="cvp-mesage-btn-container">
      <StyledBtn className="cvp-message-btn" label="Send" />
      <StyledBtn
        className="cvp-message-btn cvp-close-btn"
        label="Forkast"
        icon="pi pi-times"
        iconPos="left"
      />
    </StyledMessageButtons>
  );
};

export default NewMessageButtons;
